import React from 'react';

const FieldError = ({ children }) => (
  <div className="form-error">{ children }</div>
);

export default FieldError;
